import React from 'react';
import Navbar from '@/components/common/Navbar';
import { Separator } from '@/components/ui/separator';
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils"
import ChangePassword from '@/components/settings/ChangePassword';
import { Button, buttonVariants } from "@/components/ui/button";

const sidebarNavItems = [
    {
      title: "Change Password",
      active: false
    },
    {
      title: "Multi-Factor Authentication",
      active: false
    },
  ]
const Settings = () => {
  return (
    <div className='h-full flex-1 flex-col md:flex'>
      <Navbar />
      <div className='p-8'>
        <div className='space-y-0.5'>
          <h2 className='text-2xl font-bold tracking-tight'>Settings</h2>
          <p className='text-muted-foreground'>
            Manage your account settings and set preferences.
          </p>
        </div>
        <Separator className='my-6' />
        <div className='flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0'>
          <aside className='-mx-4 lg:w-1/5'>
            <nav className='flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1'>
              {sidebarNavItems.map((item) => (
                <Link
                  key={item.title}
                  to={item.title === "Change Password" ? "/settings" : "/mfa-settings"}
                  className={cn(
                    buttonVariants({ variant: "ghost" }),
                    item.active
                      ? "bg-muted hover:bg-muted"
                      : "hover:bg-transparent hover:underline",
                    "justify-start"
                  )}
                >
                  {item.title}
                </Link>
              ))}
            </nav>
          </aside>
          <div className='flex-1 lg:max-w-2xl'><ChangePassword /></div>
        </div>
      </div>
    </div>
  );
};

export default Settings;